module.exports = __webpack_public_path__ + "static/media/fiberpay-cobalt.b24ef81c.svg";